import { inject, Injectable } from '@angular/core';
import { Http, QueryHandlerFor } from '@skylab-angular-shared/core';
import { DataFormats } from '@skylab-shared/constants';
import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';
import { format } from 'fecha';

class InventoryStocktakingProductRecordsItemDTO {
    public readonly no: number;
    public readonly productId: number;
    public readonly name: string;
    public readonly currencyId: number;
    public readonly netPrice: number;
    public readonly grossPrice: number;
    public readonly purchaseNetPrice: number;
    public readonly purchaseGrossPrice: number;
    public readonly quantity: number;
    public readonly symbol: string;
    public readonly barCode: string;
    public readonly unitId: number;
}

export interface InventoryStocktakingProductRecordsQueryParams {
    inventoryId: number;
    stocktakingIssueDate: Date;
}

export class InventoryStocktakingProductRecordsQuery extends Query<InventoryStocktakingProductRecordsItemDTO[]> {
    public constructor(public readonly params: InventoryStocktakingProductRecordsQueryParams) {
        super();
    }
}

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(InventoryStocktakingProductRecordsQuery)
export class InventoryStocktakingProductRecordsQueryHandler implements QueryHandler<InventoryStocktakingProductRecordsQuery, InventoryStocktakingProductRecordsItemDTO[]> {
    #url = TaggedUrl.join('inventory/stocktaking/products/:inventoryId/:date', [Tags.Api]);
    #http = inject(Http) as HttpService;

    public async handleAsync(query: InventoryStocktakingProductRecordsQuery): Promise<InventoryStocktakingProductRecordsItemDTO[]> {
        const url = fillPlaceholders(this.#url, { inventoryId: query.params.inventoryId, date: format(query.params.stocktakingIssueDate, DataFormats.date.webApi) });

        const { data } = await this.#http.get<InventoryStocktakingProductRecordsItemDTO[]>(url, {
            dto: InventoryStocktakingProductRecordsItemDTO
        });

        return data;
    }
}
